const ACTION_PREPEND = 'purchase';
export const GET_CORE_CONFIG = `${ACTION_PREPEND}/GET_CORE_CONFIG`;
